import { createContext, useContext, useState, useCallback, useMemo } from "react";
import it from "./it";
import en from "./en";

const DICTS = { it, en };
const LocaleCtx = createContext({ locale: "it", t: (k) => k, setLocale: () => {} });

function lookup(dict, key) {
  return key.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), dict);
}

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => localStorage.getItem("cpi_locale") || "it");
  const setLocale = useCallback((l) => { localStorage.setItem("cpi_locale", l); setLocaleState(l); }, []);
  const t = useCallback((key, vars) => {
    let s = lookup(DICTS[locale], key) ?? lookup(DICTS.it, key) ?? key;
    if (vars && typeof s === "string") Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
    return s;
  }, [locale]);
  const value = useMemo(() => ({ locale, t, setLocale }), [locale, t, setLocale]);
  return <LocaleCtx.Provider value={value}>{children}</LocaleCtx.Provider>;
}

export const useT = () => useContext(LocaleCtx);
export const localized = (obj, field, locale) => (locale !== "it" && obj?.[`${field}_${locale}`]) || obj?.[field];
